import { Link } from '../../components/layout/Link'
import styled from '../../utils/styled'

// Action Button
export const ActionButton = styled.button`
  padding: 0.5rem 1rem;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.black};
  border: none;
  border-radius: 0.5rem;
`

// Submit Button

export const SubmitButton = styled.button`
  display: block;
  margin: 0 auto;
  max-width: 400px;
  width: 100%;
  height: 3rem;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.black};
  border: none;
  border-radius: 0.5rem;
`

// Continue Button
export const ContinueButton = styled(Link)`
  max-width: 90vw;
  width: 400px;
  height: 3rem;
  background-color: ${props => props.theme.colors.black};
  border: none;
  border-radius: 0.5rem;
  position: fixed;
  bottom: 5rem;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    bottom: 2rem;
  }
`

export const ContinueButtonText = styled.span`
  color: ${props => props.theme.colors.white};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

export const ContinueButtonBadge = styled.div`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.body};
  background-color: ${props => props.theme.colors.accent};
  line-height: 1;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  width: 30px;
  height: 30px;
`
